import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Bluetooth.17f0261e",
  "use": "Bluetooth.17f0261e-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Bluetooth.17f0261e\">\n  <path d=\"M12.418 22a.417.417 0 0 1-.416-.417v-8.635L7.7 16.89a.417.417 0 0 1-.563-.614L11.802 12 7.135 7.725a.417.417 0 0 1 .563-.614l4.303 3.942V2.417a.417.417 0 0 1 .712-.295l5 5a.417.417 0 0 1-.013.602L13.035 12l4.666 4.276c.17.155.181.419.026.589l-.012.013-5 5a.417.417 0 0 1-.297.122zm.417-9.052v7.63l3.98-3.981-3.98-3.65zm0-9.525v7.63l3.98-3.65-3.98-3.98z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol